import React from 'react';
import { Button } from './ui/button';
import { CDN } from '../data/cdnImages';

const CounselingSection = ({ onBookSession }) => {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            {/* Left - Content */}
            <div className="space-y-8">
              <div className="inline-flex items-center gap-2 bg-teal-100 px-4 py-2 rounded-full">
                <span className="text-sm font-semibold text-teal-900">Clarity over confusion</span>
              </div>

              <h2 className="font-display text-4xl lg:text-5xl font-bold text-gray-900 leading-tight tracking-tight">
                <span className="text-2xl lg:text-4xl">
                  Ready to move from&nbsp;
                  <span className="bg-gradient-to-r from-blue-600 to-teal-600 bg-clip-text text-transparent font-semibold">
                    “I guess this is fine”
                  </span>
                  &nbsp;to&nbsp;
                  <span className="bg-gradient-to-r from-blue-600 to-teal-600 bg-clip-text text-transparent font-semibold">
                    “I know why this fits”
                  </span>
                  ?
                </span>
           
              </h2>

              <div className="text-xl text-gray-600 leading-relaxed space-y-4">
                <p>
                  Most students do not crash because they lack talent. They drift because nobody translated their
                  strengths into a plan they could defend at the dinner table.
                </p>
                <p>Counselling here starts with your Career DNA read, then turns it into next steps you can act on.</p>
              </div>

              <ul className="space-y-3 text-lg text-gray-700">
                <li className="flex items-start gap-3">
                  <span className="text-teal-600 font-bold mt-0.5">✔</span>
                  <span>Understand what suits you, not only what relatives keep suggesting</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-teal-600 font-bold mt-0.5">✔</span>
                  <span>See which careers line up with your patterns and which ones will drain you</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-teal-600 font-bold mt-0.5">✔</span>
                  <span>Leave with language you can reuse when people ask “so what are you doing next?”</span>
                </li>
              </ul>

              <div className="pt-6">
                <Button 
                  onClick={onBookSession}
                  size="lg"
                  className="bg-gradient-to-r from-blue-600 to-teal-600 hover:from-blue-700 hover:to-teal-700 text-white shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 text-lg px-8 py-6"
                >
                  Book Counseling Session
                </Button>
              </div>
            </div>

            {/* Right - Image + floating testimonial (outside image, overlapping corner like before) */}
            <div className="relative space-y-6 z-0 pb-3 sm:pb-4 lg:pb-5">
              <h3 className="text-3xl lg:text-4xl font-bold text-gray-900 text-center lg:text-left">
                Let&apos;s figure this out, properly.
              </h3>
              <div className="relative rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src={CDN.counselingSession}
                  alt="Professional counseling session"
                  width={800}
                  height={600}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-auto object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-blue-900/30 to-transparent pointer-events-none" />
              </div>

              <div className="absolute z-10 left-3 -bottom-5 w-[min(15rem,calc(100%-1.5rem))] sm:left-auto sm:w-auto sm:-bottom-7 sm:-left-6 lg:-bottom-8 lg:-left-8 sm:max-w-[17.5rem] lg:max-w-sm bg-white p-3.5 sm:p-4 lg:p-6 rounded-xl lg:rounded-2xl shadow-lg lg:shadow-xl border border-gray-100">
                <div className="flex gap-0.5 sm:gap-1 mb-1.5 sm:mb-2 lg:mb-3">
                  {[...Array(5)].map((_, i) => (
                    <svg
                      key={i}
                      className="w-3.5 h-3.5 sm:w-4 sm:h-4 lg:w-5 lg:h-5 text-yellow-400 fill-current shrink-0"
                      viewBox="0 0 20 20"
                      aria-hidden
                    >
                      <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                    </svg>
                  ))}
                </div>
                <p className="text-gray-700 font-medium mb-1 sm:mb-1.5 lg:mb-2 text-[13px] leading-snug sm:text-sm lg:text-base">
                  &ldquo;The counseling session gave me clarity I never had before!&rdquo;
                </p>
                <p className="text-xs sm:text-sm text-gray-500">Riya, Class 11</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CounselingSection;
